/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CostsUsageGroupBy = {
  Model: "model",
  ApiKeyId: "api_key_id",
  TeamId: "team_id",
  ExternalUserId: "external_user_id",
  OrgId: "org_id",
} as const;
export type CostsUsageGroupBy = ClosedEnum<typeof CostsUsageGroupBy>;

/** @internal */
export const CostsUsageGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof CostsUsageGroupBy
> = z.nativeEnum(CostsUsageGroupBy);
/** @internal */
export const CostsUsageGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof CostsUsageGroupBy
> = CostsUsageGroupBy$inboundSchema;
